
import CoreFormElementInputBase from './BaseInput';
import { CoreFormElementProps } from '../../interfaces/';
import { FORM_ELEMENT_PROPS, INPUT_TYPE_MONTH } from '../../constants/';
import { HashMapMergeProps } from '../../../../../utils/';

/**
 * Month Input Element
 * @export
 * @class CoreFormElementMonth
 * @extends {CoreFormElementInputBase}
 */
export default class CoreFormElementMonth extends CoreFormElementInputBase {
  /**
   * Default Props
   * @static
   * @type {Omit<CoreFormElementProps, 'name'>}
   * @memberof CoreFormElementMonth
   */
  public static defaultProps: Omit<CoreFormElementProps, 'name'> = HashMapMergeProps(FORM_ELEMENT_PROPS, {
    type: INPUT_TYPE_MONTH,
    placeholder: 'YYYY-MM',
    pattern: '[0-9]{4}-[0-9]{2}'
  });
}
